<template>
    <div class='product-container'>
        <div v-if='loading' class='loading-container'>
            <Loading/>
        </div>
        <div  v-if='!loading' class="product-breadcrumbs">
            <div><Breadcrumbs/></div>
            <div class="product-sku">SKU <span class="code">{{product.code}}</span></div>
        </div>
        <div v-show='!loading' class='top-container'>
            <div class='outer-image-container'>
                <DynamicImageContainer v-if="product.images && product.images.length" class="product-image" :image="product.main_picture"/>
                <AddToWishList v-if='!product.is_customer_product' :product='product'/>
            </div>
            <div class="info-main-container">
                <ProductInfo :product='product' @updatedCartListener='updatedCartListener' :stock='stock'/>
            </div>
        </div>
    </div>
</template>

<script>
import ProductImages from '@/ecom/components/products/single_product/images/ProductImages.vue';
import ProductInfo from '@/ecom/components/products/single_product/details/ProductInfo.vue';
import Breadcrumbs from '@/ecom/components/products/Breadcrumbs.vue';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import AddToWishList from '@/ecom/components/products/single_product/details/AddToWishList.vue';
import Loading from '@/ecom/components/loading/Loading.vue';

import {checkAuth, setMetaTags, triggerPrerenderEvent, checkOmetriaLoaded} from "@/global/modules/functions.js";

export default {
    components: {ProductImages, ProductInfo, Breadcrumbs, DynamicImageContainer, AddToWishList, Loading},
    emits: ['updatedCartListener'],
    props: ['user_info'],
    data(){
        return{
            product: {},
            stock: {},
            total_reviews: 0,
            average_rating: 0,
            loading: true,
        }
    },
    methods:{
        async getProduct(){
            this.loading =  true;
            const product_url = this.$route.path.split('/').filter(Boolean).pop();
            let response = await fetch(`/api/product?product_url=${product_url}`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                const canonical_url = window.location.origin + this.$route.path;
                setMetaTags(results.product.meta_title, results.product.meta_description, results.product.meta_keywords, canonical_url);
                this.product = results.product;
                this.stock = results.stock;
                
                triggerPrerenderEvent();
                if(checkOmetriaLoaded()) {
                    ometria.init('product', {pid:this.product.code}, '501');
                    if(this.user_info.Email) ometria.identify(this.user_info.Email); 
                }
                this.loading =  false;
            }
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        watchForOutletSwitch(){
            window.addEventListener('storage', (event) => {   //Watch for local storage changes, this is done so can track changes across windows or tabs
                if(event.key === 'selected_outlet_watcher') {
                    setTimeout(() => {
                        this.getProduct();
                    }, 1);
                }
            });
        }
    },
    beforeMount(){
        this.getProduct();
        this.watchForOutletSwitch();
    }
}
</script>

<style lang="scss" scoped>
.product-container{
    margin-bottom: 50px;
    max-width: 1600px;
    margin: auto;
    padding: 48px;

    @media(max-width: 768px){
        padding: 24px;
    }

    // @media(max-width: 1500px){}
    // padding-left: 150px;
    // padding-right: 150px;

    // @media(max-width:1432px) {
    //     padding-left: 100px;
    //     padding-right: 100px;
    // }
    // @media(max-width:1332px) {
    //     padding-left: 80px;
    //     padding-right: 80px;
    // } 
    // @media(max-width:1024px) {
    //     padding-left: 50px;
    //     padding-right: 50px;
    // }  
    // @media(max-width:768px) {
    //     padding-left: 20px;
    //     padding-right: 20px;
    // }       
}
.top-container{
    display: flex;
    gap: 70px;
    margin-top: 30px;
    // margin-bottom: 50px;
    padding-left: 50px;
    padding-right: 50px;

    @media(max-width:768px) {
        flex-wrap: wrap;
        gap: 24px;
        justify-content: center;
        padding-left: 0px;
        padding-right: 0px;
    }
}

.outer-image-container{
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;

    @media(max-width: 768px){
        width: 100%;
        margin: auto;
    }
}

.product-image{
    width: 140px;
    object-fit: cover;
    text-align: left;
}
.info-main-container{
    width:100%;
}
.product-breadcrumbs{
    display:flex;
    justify-content: space-between;
    // margin-top: 34px;

    @media(max-width: 768px){
        gap: 12px;
        flex-direction: column;
    }
}
.product-sku{
    font-size: 1rem;
    font-weight: 400;
    line-height: 24px;
}
.code{
    font-weight: 600;
    padding-left: 4px;
    padding-right: 4px;
}
.loading-container{
    width: 75px;
    height: 75px;
    margin: auto;
    margin-top: 50px;
}
</style>